export default {
  jobListingCandidateComments: [],
  jobListingCandidateComment: undefined,
};
